<template>
  <div :class="['deposit-mtaccountList', isDialogInner ? '' : 'notDialogInner']">
    <el-row
      class="mobile-row"
    >
      <el-col
        :lg="lgCol"
        :sm="smCol"
        :xs="24"
      >
        <!--        需要用一个假的tag  标签盒子代替有值的select,然后真正的el-select 在正上方,透明度未0, todo-->
        <div class="out-box">
          <el-select
            class="self-select"
            style="width: 100%"
            v-model="curLogin"
            :popper-append-to-body = "false"
            :placeholder="$t('please_choose')"
            @change="accountListChange"
          >
            <el-option
              class="self-mtlist-select"
              v-for="(item,index) in computedAccountList"
              :key="index"
              :label="getLabel(item)"
              :value="item.login"
            >
              <div
                class="account-inner">
                <div class="account-top">
                  <img
                    class="icon-el"
                    src="../../assets/images/customer/MT4.png"
                    alt=""
                  >
                  <span class="login">MT4 ({{item.login}})</span>
                </div>
                 <p class="inner-bot"> <span class="margin-free"><div class="adaptiveText">{{$t('User.reportEquity')}} :</div> <div class="adaptiveText">{{item.equity}} {{item.currency}}</div></span><span class="margin-free"><div class="adaptiveText">{{$t('User.marginFree')}} :</div><div class="adaptiveText"> {{item.marginFree}} {{item.currency}}</div></span></p>
              </div>
            </el-option>
          </el-select>
          <div class="farke-box">
            <div class="farke-box-left">
              <div class="account-top">
                <img
                  class="icon-el"
                  src="../../assets/images/customer/MT4.png"
                  alt=""
                >
                <span class="login">MT4 ({{currentMt4Info.login}})</span>
              </div>
              <p class="inner-bot"><span class="margin-free"><div class="adaptiveText">{{$t('User.reportEquity')}}:</div><div class="adaptiveText"> {{currentMt4Info.equity}} {{currentMt4Info.currency}}</div></span><span class="margin-free"><div class="adaptiveText">{{$t('User.marginFree')}}:</div><div class="adaptiveText"> {{currentMt4Info.marginFree}} {{currentMt4Info.currency}}</div></span></p>
            </div>
            <!--            <div
                          v-if="!curLogin"
                          class="farke-right">
                          <i class="el-icon-arrow-down"></i>
                        </div>-->
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import {mtAccList} from "@/api/userCenter";
import { mapGetters } from 'vuex'
export default {
  name: "mtaccountList",
  props: {
    excludeLogin: {
      // type: Number,
    },
    isDialogInner:{
      type: Boolean,
      default: false,
    }
  },
  components: {
  },
  data() {
    return {
      curLogin: '',
      accountList: [],
    }
  },
  computed: {
    ...mapGetters(['userInfo','realMobile','themeColor','depositAccount']),
    currentMt4Info(){
      let info = {};
      for (let i = 0; i < this.accountList.length; i++) {
        if(this.accountList[i].login == this.curLogin){
          info = this.accountList[i];
          break;
        }
      }
      return info;
    },
    computedAccountList(){
      if(!this.excludeLogin){
        return this.accountList;
      }else {
        let filterArr = this.accountList.filter((item) => {
          return item.login != this.excludeLogin;
        })
        return filterArr;
      }
    },
    lgCol(){
      if(this.isDialogInner){
        return 24;
      }
      if(window.innerWidth > 1280){
        return 12;
      }else {
        return 12;
      }
    },
    smCol(){
      if(this.isDialogInner){
        return 24;
      }
      if(window.innerWidth > 1280){
        return 12;
      }else {
        return 12;
      }
    },
  },
  created(){
    this.getCustMtaccount((data) => {
      if(this.depositAccount){
        this.curLogin = this.depositAccount;
      }else {
        if(this.computedAccountList.length){
          this.curLogin = this.computedAccountList[0].login;
        }else {
          this.curLogin = '';
        }
      }
    });
  },
  beforeDestroy(){
    // 从首页或者copyMaster中点击转账,需要记住是哪个账号
    this.$store.commit('setDepositAccount','');
  },
  methods: {
    getLabel(item){
      return `MT4 (${item.login}) ${this.$t('balance')}: $${item.balance}`;
    },
    getCustMtaccount(callback) {
      let parmas = {
        id: this.userInfo.id,
        businessTypes: '0,1,2,3',
      };
      mtAccList(parmas).then((res) => {
        this.accountList = res.data;
        this.$emit('send-accountList',this.accountList);
        callback && callback(res.data);
        this.$emit('send-currentMtInfo',this.currentMt4Info);
      });
    },
    accountListChange(){
      this.$emit('send-currentMtInfo',this.currentMt4Info);
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variable";
.adaptiveText{
  display: inline-block;
}
// 移动端样式
@media screen and (max-width: 768px){
  .el-select-dropdown{
    .el-select-dropdown__item{
      max-width: none;
    }
  }
}
@media screen and (max-width:992px){
  .adaptiveText{
    display: block;
  }
}
.deposit-mtaccountList {
  .mobile-row {
    .account-inner {
      width: 100%;
    }
  }
}

.notDialogInner{
  /deep/ .el-select-dropdown{
    width: 100% !important;
  }
} 

.self-mtlist-select {
  height: 86px;
  .inner-bot {
    padding-left: 34px;
    width: 100%;
    .margin-free{
        width: 50%;
        display: inline-block;
    }
  }
}
.account-top {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .icon-el {
    width: 24px;
    height: 24px;
  }
  .login {
    padding-left: 10px;
    font-weight: 600;
    font-size: 14px;
  }

}
.out-box {
  position: relative;
  height: 100px;

  .farke-box {
    position: absolute;

    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    border: 1px solid #D8D6DE;
    .inner-bot {
      padding-left: 34px;
      width: 100%;
    }
    .inner-bot{
      width: 100%;
      .margin-free{
        width: 50%;
        display: inline-block;
      }
    }
    .farke-box-left{
      width: 100%;
    }
    
  }

  .farke-box,
  .self-select, {
    position: absolute;
    width: 100%;
    height: 100px;

    border-radius: 6px;
  }

  .self-select {
    position: absolute;

    /deep/ {
      .el-input,
      .el-input__inner {
        position: absolute;
        width: 100%;
        height: 100px;
        z-index: 999;
        border-radius: 6px;
      }

      .el-input__inner {
        z-index: 9999;
        opacity: 0;
      }
    }
  }
}

</style>
